import { render, staticRenderFns } from "./details.vue?vue&type=template&id=d2958b5a&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=d2958b5a&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=d2958b5a&prod&lang=scss"
import style2 from "./details.vue?vue&type=style&index=2&id=d2958b5a&prod&scoped=true&lang=css"
import style3 from "./details.vue?vue&type=style&index=3&id=d2958b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2958b5a",
  null
  
)

export default component.exports